(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2872],{

/***/ 99418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82030);
/* harmony import */ var src_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67455);
/* harmony import */ var src_pages_Allocations_V2_Tables_AllocationTableBody_AllocationTableBody_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28643);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80822);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var withAdminAuthHandler = function withAdminAuthHandler(WrappedComponent) {
  var redirectUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/audience";

  var Wrapper = function Wrapper(props) {
    var _useAuthContext = (0,src_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_3__/* .useAuthContext */ .E)(),
        user = _useAuthContext.user;

    var children = props.children;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();

    var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true),
        loading = _useState[0],
        setLoading = _useState[1];

    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
      if (user) {
        var _user$roles;

        if (!((_user$roles = user.roles) !== null && _user$roles !== void 0 && _user$roles.includes('Administrator'))) {
          router.replace(redirectUrl);
        } else {
          setLoading(false);
        }
      }
    }, [user]);

    if (loading) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        sx: {
          height: "100vh"
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(src_pages_Allocations_V2_Tables_AllocationTableBody_AllocationTableBody_styles__WEBPACK_IMPORTED_MODULE_5__/* .SpinnerContainer */ .eg, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(src_components__WEBPACK_IMPORTED_MODULE_4__/* .LoadingSpinner */ .TK, {
            color: "inherit"
          }), ";"]
        })
      });
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(WrappedComponent, _objectSpread(_objectSpread({}, props), {}, {
      children: children
    }));
  };

  return Wrapper;
};

/* harmony default export */ __webpack_exports__["Z"] = (withAdminAuthHandler);

/***/ }),

/***/ 8885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22877);
/* harmony import */ var src_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82030);
/* harmony import */ var src_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67455);
/* harmony import */ var src_pages_Allocations_V2_Tables_AllocationTableBody_AllocationTableBody_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28643);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80822);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var withAuthHandler = function withAuthHandler(WrappedComponent) {
  var redirectUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/login";

  var Wrapper = function Wrapper(props) {
    var _useAuthContext = (0,src_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_4__/* .useAuthContext */ .E)(),
        user = _useAuthContext.user;

    var children = props.children;

    var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true),
        loading = _useState[0],
        setLoading = _useState[1];

    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
      var isExpiredOrNull = (0,_utils_auth__WEBPACK_IMPORTED_MODULE_3__/* .isTokenExpiredOrNull */ .ji)();

      if (user) {
        if (isExpiredOrNull) {
          router.replace({
            pathname: redirectUrl,
            query: {
              redirectUrl: router.asPath
            }
          });
        } else {
          setLoading(false);
        }
      } else {
        setLoading(false);
        router.replace({
          pathname: redirectUrl,
          query: {
            redirectUrl: router.asPath
          }
        });
      }
    }, [user]);

    if (loading) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        sx: {
          height: "100vh"
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(src_pages_Allocations_V2_Tables_AllocationTableBody_AllocationTableBody_styles__WEBPACK_IMPORTED_MODULE_6__/* .SpinnerContainer */ .eg, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(src_components__WEBPACK_IMPORTED_MODULE_5__/* .LoadingSpinner */ .TK, {
            color: "inherit"
          }), ";"]
        })
      });
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(WrappedComponent, _objectSpread(_objectSpread({}, props), {}, {
      children: children
    }));
  };

  return Wrapper;
};

/* harmony default export */ __webpack_exports__["Z"] = (withAuthHandler);

/***/ }),

/***/ 98886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HealthScoreBar; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81458);
/* harmony import */ var _HealthScoreBar_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20242);
/* harmony import */ var _HealthScoreBar_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_HealthScoreBar_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);





function HealthScoreBar(props) {
  var score = props.score,
      _props$childType = props.childType,
      childType = _props$childType === void 0 ? "Sessions" : _props$childType;
  var colors = {
    success: "#2e7d32",
    warning: "#ed6c02",
    error: "#d32f2f"
  };

  var barColorCalc = function barColorCalc(score) {
    if (typeof score === 'undefined' || score < 25) {
      return colors.error;
    } else if (score >= 25 && score < 50) {
      return colors.warning;
    } else {
      return colors.success;
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: score == -1 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      className: (_HealthScoreBar_module_scss__WEBPACK_IMPORTED_MODULE_2___default().HealthScoreBar),
      sx: {
        opacity: 0.5
      },
      "data-value": "no-sessions",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (_HealthScoreBar_module_scss__WEBPACK_IMPORTED_MODULE_2___default().text),
        variant: "caption",
        children: ["No ", "".concat(childType.charAt(0).toUpperCase()).concat(childType.slice(1))]
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      className: (_HealthScoreBar_module_scss__WEBPACK_IMPORTED_MODULE_2___default().HealthScoreBar),
      sx: {
        color: barColorCalc(score)
      },
      "data-value": typeof score == "undefined" ? "no-score" : "valid-score",
      children: typeof score == "undefined" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        variant: "indeterminate",
        sx: {
          mt: "3px",
          width: "100%",
          opacity: 0.5
        },
        color: "inherit"
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          className: (_HealthScoreBar_module_scss__WEBPACK_IMPORTED_MODULE_2___default().text),
          variant: "body1",
          sx: {
            color: "inherit"
          },
          children: [score, " / 100"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          variant: "determinate",
          sx: {
            mt: "3px",
            width: "100%"
          },
          color: "inherit",
          value: score
        })]
      })
    })
  });
}

/***/ }),

/***/ 96204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Page_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68491);
/* harmony import */ var _Page_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Page_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var Page = function Page(props) {
  var className = props.className,
      children = props.children;
  var classes = classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Page_module_scss__WEBPACK_IMPORTED_MODULE_3___default().page), (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, className, className));
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: classes,
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Page);

/***/ }),

/***/ 52240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42293);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65582);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10155);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93946);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(25464);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(18972);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69417);
/* harmony import */ var _mui_icons_material_Menu__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(326);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dist_client_with_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94269);
/* harmony import */ var next_dist_client_with_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dist_client_with_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22877);
/* harmony import */ var src_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67455);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);











var defaultRoute = "/shows";
var pages = [{
  title: "Shows",
  route: "/shows"
}, {
  title: "Allocations",
  route: "/allocations/my-allocations"
}, {
  title: "Allocations V2",
  route: "/allocations-v2/my-allocations"
}, {
  title: "Users",
  route: "/users"
}, {
  title: "Rules",
  route: "/rules"
}
/* { title: 'Boilerplate', route: '/boilerplate' }, 'Guarded'*/
];

var ResponsiveAppBar = function ResponsiveAppBar(_ref) {
  var _ref$showMenu = _ref.showMenu,
      showMenu = _ref$showMenu === void 0 ? true : _ref$showMenu,
      router = _ref.router,
      user = _ref.user;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      anchorElNav = _useState[0],
      setAnchorElNav = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      anchorElUser = _useState2[0],
      setAnchorElUser = _useState2[1];

  var isViewAs = (0,_utils_auth__WEBPACK_IMPORTED_MODULE_4__/* .isViewAsActive */ .cr)();

  var handleOpenNavMenu = function handleOpenNavMenu(event) {
    setAnchorElNav(event.currentTarget);
  };

  var handleOpenUserMenu = function handleOpenUserMenu(event) {
    setAnchorElUser(event.currentTarget);
  };

  var handleCloseNavMenu = function handleCloseNavMenu() {
    setAnchorElNav(null);
  };

  var handleCloseUserMenu = function handleCloseUserMenu() {
    setAnchorElUser(null);
  };

  var handleNavigation = function handleNavigation(route) {
    setAnchorElNav(null);
    router.push(route === defaultRoute ? "/" : route);
  };

  var handleLogin = function handleLogin() {
    router.replace("/login?redirectUrl=".concat(router.asPath));
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    className: "responsiveAppBar",
    position: "static",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      maxWidth: "xl",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        disableGutters: true,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
          sx: {
            flexGrow: 1,
            display: "flex",
            flexDirection: "row"
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            sx: {
              display: {
                xs: "flex",
                md: "none"
              }
            },
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
              size: "large",
              "aria-label": "account of current user",
              "aria-controls": "menu-appbar",
              "aria-haspopup": "true",
              onClick: handleOpenNavMenu,
              color: "inherit",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_icons_material_Menu__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
            }), showMenu && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
              id: "menu-appbar",
              anchorEl: anchorElNav,
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left"
              },
              keepMounted: true,
              transformOrigin: {
                vertical: "top",
                horizontal: "left"
              },
              open: Boolean(anchorElNav),
              onClose: handleCloseNavMenu,
              sx: {
                display: {
                  xs: "block",
                  md: "none"
                }
              },
              children: pages.map(function (page) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                  onClick: function onClick() {
                    return handleNavigation(page.route);
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    textAlign: "center",
                    children: page.title
                  })
                }, page.title);
              })
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: "/",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
              src: "/images/logo-white.webp",
              width: "143",
              height: "70",
              alt: "That's The Ticket logo",
              title: "That's The Ticket"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            sx: {
              flexGrow: 1,
              display: {
                xs: "none",
                md: "flex"
              }
            },
            children: showMenu && pages.map(function (page) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: page.route,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                  className: page.title.toLocaleLowerCase() + "-navigation",
                  sx: {
                    my: 2,
                    color: "white",
                    display: "block"
                  },
                  children: page.title
                })
              }, page.title);
            })
          })]
        }), !user ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(src_components__WEBPACK_IMPORTED_MODULE_5__/* .LoadingSpinner */ .TK, {
          color: "inherit"
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            "data-cy": "login-status",
            sx: {
              flexGrow: 0
            },
            children: [user !== null && user !== void 0 && user.email ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
              sx: {
                display: "flex"
              },
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                "data-cy": "navbar-username",
                onClick: handleOpenUserMenu,
                sx: {
                  p: 0,
                  cursor: "pointer"
                },
                style: isViewAs ? {
                  color: "orange"
                } : {},
                children: user !== null && user !== void 0 && user.firstName && user !== null && user !== void 0 && user.lastName ? (isViewAs ? "Viewing as " : "") + "".concat(user === null || user === void 0 ? void 0 : user.firstName, " ").concat(user === null || user === void 0 ? void 0 : user.lastName) : "Guest User - ".concat(user === null || user === void 0 ? void 0 : user.email)
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                sx: {
                  px: "10px"
                },
                children: "|"
              }), isViewAs ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                onClick: function onClick() {
                  return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_4__/* .stopViewAs */ .zZ)();
                },
                sx: {
                  p: 0,
                  cursor: "pointer"
                },
                children: "Stop view as"
              }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                "data-cy": "login-status-with-user",
                onClick: function onClick() {
                  return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_4__/* .logoutUser */ .TX)();
                },
                sx: {
                  p: 0,
                  cursor: "pointer"
                },
                children: "Log out"
              })]
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
              "data-cy": "login-status-no-user",
              onClick: function onClick() {
                return handleLogin();
              },
              sx: {
                p: 0,
                cursor: "pointer"
              },
              children: "Login"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
              sx: {
                mt: "45px"
              },
              id: "menu-appbar",
              anchorEl: anchorElUser,
              anchorOrigin: {
                vertical: "top",
                horizontal: "right"
              },
              keepMounted: true,
              transformOrigin: {
                vertical: "top",
                horizontal: "right"
              },
              open: Boolean(anchorElUser),
              onClose: handleCloseUserMenu,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                onClick: handleCloseUserMenu,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                  href: "/profile",
                  children: "Profile"
                })
              }, 0)
            })]
          })
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (next_dist_client_with_router__WEBPACK_IMPORTED_MODULE_2___default()(ResponsiveAppBar));

/***/ }),

/***/ 28643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FD": function() { return /* binding */ ErrorTooltipContainer; },
/* harmony export */   "Ti": function() { return /* binding */ TableBodyCell; },
/* harmony export */   "ab": function() { return /* binding */ OverflowControl; },
/* harmony export */   "eg": function() { return /* binding */ SpinnerContainer; },
/* harmony export */   "f2": function() { return /* binding */ RightContainer; },
/* harmony export */   "hZ": function() { return /* binding */ TotalTickets; },
/* harmony export */   "sh": function() { return /* binding */ TableBodyRow; }
/* harmony export */ });
/* unused harmony exports WarningTooltipContainer, Value, EmptyTitle, EmptyMessage */
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90948);


var RightContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref) {
  var theme = _ref.theme,
      modalStyling = _ref.modalStyling;
  return {
    backgroundColor: theme.colors["neutral.900"],
    borderBottomRightRadius: '1rem',
    height: '100%',
    position: 'relative',
    color: theme.colors["neutral.300"],
    overflow: 'hidden',
    "&:after": {
      content: '""',
      background: modalStyling ? 'linear-gradient(270deg, rgba(33, 33, 33, 0.9) 0%, rgba(33, 33, 33, 0) 100%)' : 'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(9,9,9,1) 130%)',
      width: '10rem',
      position: 'absolute',
      right: '0',
      top: '0',
      height: '100%',
      pointerEvents: 'none',
      "@media (max-width: 600px)": {
        background: modalStyling ? 'linear-gradient(270deg, rgba(33, 33, 33, 0.9) 0%, rgba(33, 33, 33, 0) 100%)' : 'linear-gradient(90deg, rgba(255,255,255,0) 60%, rgba(9,9,9,0.8) 130%)'
      }
    },
    "&:before": {
      content: '""',
      background: modalStyling ? 'linear-gradient(270deg, rgba(33, 33, 33, 0.9) 0%, rgba(33, 33, 33, 0) 100%)' : 'linear-gradient(90deg, rgba(9,9,9,.6) 0%, rgba(255,255,255,0) 100%)',
      position: 'absolute',
      pointerEvents: 'none',
      left: '0',
      top: '0',
      transition: 'opacity ease-in-out .3s',
      height: '100%',
      width: '10rem',
      opacity: '0',
      zIndex: '1',
      "@media (max-width: 600px)": {
        background: modalStyling ? 'linear-gradient(270deg, rgba(33, 33, 33, 0.9) 0%, rgba(33, 33, 33, 0) 100%)' : 'linear-gradient(90deg, rgba(9,9,9,.6) 0%, rgba(255,255,255,0) 30%)'
      }
    },
    "&.shadow": {
      "&:before": {
        content: '""',
        opacity: '1'
      }
    }
  };
});
var SpinnerContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: "flex",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: "4rem",
    color: theme.colors["neutral.200"]
  };
});
var OverflowControl = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref3) {
  var theme = _ref3.theme;
  return {
    position: 'absolute',
    width: '100%',
    transition: 'all .8s cubic-bezier(.33,.4,0,.96)'
  };
});
var ErrorTooltipContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref4) {
  var theme = _ref4.theme;
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.colors["red.500"],
    fontSize: theme.fontSizes.xs,
    fontFamily: theme.fonts["default"]
  };
});
var WarningTooltipContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref5) {
  var theme = _ref5.theme;
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.colors["yellow.400"],
    fontSize: theme.fontSizes.xs,
    fontFamily: theme.fonts["default"]
  };
});
var TableBodyRow = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref6) {
  var theme = _ref6.theme,
      isHighlighted = _ref6.isHighlighted;
  return {
    display: 'grid',
    gridAutoFlow: 'column',
    height: '60px',
    justifyContent: 'space-evenly',
    paddingLeft: '1rem',
    border: isHighlighted ? "2px solid ".concat(theme.colors["blue.500"]) : 'none',
    borderLeft: "none",
    transition: "border 200ms ease-in-out",
    "&:nth-of-type(odd)": {
      backgroundColor: theme.colors["neutral.950"],
      ".cell": {
        backgroundColor: theme.colors["neutral.950"]
      }
    },
    "@media (max-width: 600px)": {
      height: "70px"
    }
  };
});
var TableBodyCell = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref7) {
  var theme = _ref7.theme;
  return {
    width: '112px',
    display: 'grid',
    padding: '0.4rem 0.5rem 0 0.5rem',
    alignItems: 'center',
    justifyContent: 'center',
    gridTemplateRows: 'auto 16px',
    gridTemplateColumns: "1fr",
    position: 'relative',
    '&:hover [data-slot="input"]': {
      background: theme.colors["neutral.950"]
    },
    '&:hover [data-slot="root"]': {
      border: "1px solid ".concat(theme.colors["neutral.700"]),
      boxShadow: "0 2px 4px ".concat(theme.colors["neutral.950"]),
      opacity: 1
    },
    '[data-slot="incrementButton"], [data-slot="decrementButton"]': {
      display: 'flex',
      opacity: 0,
      transition: 'all 0.3s ease'
    },
    '&:hover [data-slot="incrementButton"], &:hover [data-slot="decrementButton"]': {
      display: 'flex',
      opacity: 1
    }
  };
});
var TotalTickets = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function (_ref8) {
  var theme = _ref8.theme;
  return {
    fontSize: theme.fontSizes.lg,
    fontFamily: theme.fonts["default"],
    color: theme.colors["neutral.50"],
    fontWeight: theme.fontWeights.bold,
    textAlign: 'center'
  };
});
var Value = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function (_ref9) {
  var theme = _ref9.theme;
  return {
    marginTop: '12px',
    width: '100px',
    color: theme.colors["neutral.50"],
    fontSize: theme.fontSizes.lg,
    fontFamily: theme.fonts["default"],
    textAlign: 'center',
    position: 'relative'
  };
});
var EmptyTitle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function (_ref10) {
  var theme = _ref10.theme;
  return {
    color: theme.colors["neutral.50"],
    fontSize: theme.fontSizes["2xl"],
    fontWeight: theme.fontWeights.bold,
    fontFamily: theme.fonts["default"]
  };
});
var EmptyMessage = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function (_ref11) {
  var theme = _ref11.theme;
  return {
    color: theme.colors["neutral.500"],
    fontSize: theme.fontSizes.lg,
    fontFamily: theme.fonts["default"],
    margin: '1rem 0',
    maxWidth: '40rem',
    textAlign: 'center'
  };
});

/***/ }),

/***/ 20242:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"HealthScoreBar":"HealthScoreBar_HealthScoreBar__XX2d7","text":"HealthScoreBar_text__FIQW1"};

/***/ }),

/***/ 68491:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__LFdNN"};

/***/ })

}]);